class CommerceProductPricingTV {
    constructor() {
        let tvs = document.querySelectorAll('.commerce-pricingtv');

        for (let i = 0; i < tvs.length; i++) {
            let valueField = tvs[i].querySelector('.commerce-pricingtv-value'),
                savedValue = valueField.value;

            try {
                savedValue = JSON.parse(savedValue);
            }
            catch (e) {
                savedValue = {};
            }

            // Make sure we have an object - don't accept numbers or other types that JSON.parse might spit out
            if (typeof savedValue !== 'object' || typeof savedValue === 'null') {
                savedValue = {};
            }

            Commerce.Fields.enhancePricingFields(tvs[i], function(value, currency) {
                savedValue[currency.alpha_code] = JSON.parse(value);
                valueField.value = JSON.stringify(savedValue);
            });
        }
    }
}
